import './App.css';
import Calculator from "./components/calculator.jsx"

function App() {
  return (
    <div className="App">
      <Calculator></Calculator>
    </div>
  );
}

export default App;
